module.exports = __webpack_public_path__ + "b6b440f53ae8ff81a9c532a669ed925e.pdf";